import { gql } from '@apollo/client';

export const FETCH_ACCESS_CONTROLS = gql`
    query fetchAccessControls {
        system {
            accessControls {
                key
                description
            }
        }
    }
`;
